<script>
import ProInput from '$common/ProInput'
import ProSelect from '$common/ProSelect'
export default {
  name: 'CreateDiscountCode',
  components: {
    'pro-input': ProInput,
    'pro-select': ProSelect
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      discountCode: {
        code: '',
        amount: '',
        status: false,
      },
      formOptions: {
        code: {
          title: 'Code',
          errorIf: (val) => val ? '' : 'Enter Code',
        },
        amount: {
          title: 'Amount',
          type: 'number',
          errorIf: val => val >= 1 ? '' : 'Amount must be greater than 0'
        },
        status: {
          title: 'Status',
          type: 'checkbox',
          prompt: 'Active',
          errorIf: val => '', 
        },
      },
      editing: false,
      saving: false,
    }
  },
  methods: {
    async onSubmit(){
      const errors = await this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, class: 'alert'}))

      this.saving = true
      const codeId = this.editing ? this.options.info.id : this.$firestore.collection('discount_codes').doc().id
      const codeRef = this.$firestore.collection('discount_codes').doc(codeId)

      //set codeData to the appropriate firebase call
      let codeData
      const formattedCodeInfo = {
        code: this.discountCode.code.toUpperCase(),
        amount: this.discountCode.amount,
        status: this.discountCode.status ? "ACTIVE" : "EXPIRED"
      }
      
      if (this.editing) {
        codeData = codeRef.update({
          ...formattedCodeInfo
        })
      } else {
        codeData = codeRef.set({
          id: codeId,
          ...formattedCodeInfo
        })
      }

      try {
        await Promise.resolve(codeData)
      } catch (e) {
        console.error(e)
        this.$toast('Code was not saved. Please try again.')
        this.saving = false
        return
      }

      this.saving = false
      this.$toast(`Discount Code ${this.editing ? 'updated' : 'created'}.`)
      this.$modals.hide('create-discount-code')

      const successFunc = this.options.onSuccess
      if (successFunc) successFunc()
    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        const checkErrorIfs = () => Object.keys(this.discountCode)
          .map(key => this.formOptions[key].errorIf(this.discountCode[key]))
          .filter(Boolean)

        const codeErrors = checkErrorIfs()

        resolve([
          ...codeErrors,
        ])
      })
    },
  },
  async mounted () {
    if (this.options.info) {
      this.editing = true
      Object.keys(this.discountCode).forEach((key) => {
        if (key === 'status') 
          this.discountCode.status = (this.options.info.status === 'ACTIVE')
        else this.discountCode[key] = this.options.info[key]
      })
    } else {
      this.discountCode.status = true
    }
  },
}
</script>

<template lang="pug">
  #discount-code-main.modal-main
    .discount-code-container.modal-container
      .title {{options.info ? 'Edit' : 'Create'}} Discount Code
      .content
        .discount-code-section
          .form-holder
            .pro-form
              .form-row(
                v-for='(options, key, idx) in formOptions'
              )
                pro-input(
                  :options='options'
                  v-model='discountCode[key]'
                )

      .action
        .button.minor(
          @click='$modals.hide(`create-discount-code`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) {{saving ? "Saving..." : "Save Discount Code"}}
</template>

<style lang="sass" scoped>
.form-row
</style>